'use client';

import { cn } from '@baseball-near-you/ui';
import { dayjsExt } from '@bb/lib/dayjs';
import { getBlogAnalyticsProperties } from '@bb/lib/posthog/utils';
import Link from 'next/link';
import posthog from 'posthog-js';
import { ResponsiveNextImage } from '../ResponsiveNextImage';
import { ClickEventType } from '../TrackingButton/types';

export function BlogPostLink({
  id,
  category,
  className,
  date,
  excerpt,
  slug,
  title,
  imageUrl,
}: {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  date: Date;
  category: string;
  className?: string;
  imageUrl?: string;
}) {
  return (
    <Link
      key={category + title}
      href={`/blog/${slug}`}
      prefetch={false}
      onClick={() => {
        posthog.capture(ClickEventType.BlogCarouselClicked, {
          ...getBlogAnalyticsProperties({
            id,
            title,
            slug,
            excerpt,
          }),
          category,
        });
      }}
    >
      <div
        className={cn(
          'inline-block overflow-hidden rounded-md border shadow-xs transition-all hover:border-gray-300 hover:shadow-md',
          className
        )}
      >
        <div className="relative flex items-center justify-center border-b bg-white">
          {imageUrl ? (
            <ResponsiveNextImage
              containerClassName="relative h-[190px] w-full"
              nextImageProps={{
                alt: 'cropped result',
                fill: true,
                style: {
                  objectFit: 'cover',
                  objectPosition: 'center center',
                },
                className: 'h-full w-full',
                src: imageUrl,
              }}
            />
          ) : (
            <div className="h-[190px] w-full bg-gray-100" />
          )}
        </div>
        <div className="flex h-32 flex-col justify-between p-4">
          <div>
            <p className="title mb-0 w-full truncate text-black">{title}</p>
            <p className="mb-0 line-clamp-2 text-gray-700 text-sm">{excerpt}</p>
          </div>
          <p className="title mt-2 w-min whitespace-nowrap text-gray-600 text-xs">
            {dayjsExt(date).format('MMMM Do, YYYY')}
          </p>
        </div>
      </div>
    </Link>
  );
}
